<template>
  <div>
    <div class="semester-totals" v-if="minDetected">
      {{name}} <!-- ({{minCredits}}-{{totalCredits}} Units) -->
    </div>
    <div class="semester-totals" v-else>
      {{name}} <!-- ({{totalCredits}} Units) -->
    </div>
    <usc-course-card v-for="(course, index) in semester" :course="course" :key="index">
    </usc-course-card>
    <div class="semester-totals" v-if="minDetected">
      &nbsp; <!-- {{name}} ({{minCredits}}-{{totalCredits}} Units) -->
    </div>
    <div class="semester-totals" v-else>
      &nbsp; <!-- {{name}} ({{totalCredits}} Units) -->
    </div>
  </div>
</template>

<script>
import CourseCard from '@/components/CourseChart/CourseCard'

export default {
  name: 'CourseSemester',
  components: {
    'usc-course-card': CourseCard
  },
  props: ['semester', 'name'],
  data () {
    return {

    }
  },
  computed: {
    minDetected () {
      let i = 0
      let min = false
      for (i = 0; i < this.semester.length; i++) {
        if (this.semester[i].hasMin === true) {
          min = true
          break
        }
      }
      return min
    },
    minCredits () {
      let i = 0
      let sum = 0
      for (i = 0; i < this.semester.length; i++) {
        sum += this.semester[i].min
      }
      return sum
    },
    totalCredits () {
      return this.semester.reduce(function (sum, credits) {
        sum += credits.courseCredits
        return sum
      }, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .semester-totals {
    color: $cBody;
    align-self: flex-start;
    text-transform: capitalize;
    font-family: $fNational;
    font-size: 17px;
    font-weight: $fRegular;
    margin-top: 0px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseChart/CourseSemester.vue